import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SlidingPane from "react-sliding-pane";
import Button from "../../../views/buttons/Button";
import Card from "../../../views/datacard/Card";
import InputTextField from "../../../views/inputfield/InputTextField";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import NoDataComponent from "../../../Components/noDataComponent/NoDataComponent";
import { Capitalize, CATCH_MESSAGE, getImage } from "../../../UtilityFunctions";
import Hotel from "../../../assests/img/hotel-image.png";
import CustomBreadcrumbs from "../../../Components/breadCrumb/CustomBreadcrumbs";
import CardWrapper from "../../../views/datacard/CardWrapper";
import DropzoneArea from "../../../views/customDropzone/DropzoneArea";
import { toast } from "react-toastify";
import wbApi from "../../../API/wbApi";
import { HotelServicesDataAction } from "../../../redux/actions/SectionAction";
import { CancelConfirmationPrompt, ShowConfirmationPrompt } from "../../../redux/actions/PromptAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons";

const EditServices = () => {
  // Data From Redux
  const { company_id, auth_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { template_id } = useSelector((state: RootState) => state.template_id);
  const { defaultSectionId } = useSelector(
    (state: RootState) => state.sections
  );

  //  States
  const [loader, setLoader] = useState<boolean>(false);

  const [categoryOpen, setCategoryOpen] = useState(false);
  const [sectionId, setSectionId] = useState<any>("");
  const [gallerySectionDetails, setGallerySectionDetails] = useState<any>();
  const [categoryList, setCategoryList] = useState<any[]>([]);
  const [galleryId, setGalleryId] = useState<any>("");
  const [titleText, setTitleText] = useState<any>("");
  const [altText, setAltText] = useState("");
  const [description, setDescription] = useState<any>("");
  const [charCount, setCharCount] = useState({
    child: 0,
    privacy: 0,
    terms_cond: 0,
    cancellation: 0,
  });
  const [hotelDetails, setHotelDetails] = useState<any[]>([]);
  const [serviceData, setServiceData] = useState<any>();
  const [serviceSecImage, setServiceSecImage] = useState<any[]>([]);
  const [editServicefiles, setEditServiceFiles] = useState<any[]>([]);
  const [serviceId, setServiceId] = useState<any>("undefined");
  const [refreshList, setRefreshList] = useState<boolean>(false);
  const [hotelServicesData, setHotelServicesData] = useState<any>({
    hotel_services: [],
    all_icons: [],
    selected_services: [],
  });

  const accpServiceFiles = (value: any) => {
    setEditServiceFiles(value);
  };

  const delteServiceFiles = (value: any) => {
    if (value) {

      dispatch(
        ShowConfirmationPrompt(
          `Are you sure want to delete this ?`,
          "DELETE",
          async () => {
            await delteServiceSecFilesApi();

            dispatch(CancelConfirmationPrompt());
          }
        )
      );
    }
  };
  // Variables
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function removeTags(str: String) {
    str = str.toString();
    const finalStr = str.replace(/&nbsp;/g, " ");
    return finalStr.replace(/(<([^>]+)>)/gi, ""); // Regular expression to identify HTML tags in the input string. Replacing the identified,HTML tag with a null string.
  }

  useEffect(() => {
    fetchSection();
  }, [company_id, template_id, defaultSectionId]);
  // Data Fetching
  const fetchSection = async () => {
    try {
      let SectionRes = await wbApi.get(
        `/wb-dashboard/fetch-wb-services-section-details/${company_id}/${template_id}/${defaultSectionId}`
      );
      if (SectionRes.data.status === 1) {
        setServiceData(SectionRes.data.services_section_details);
        setHotelDetails(SectionRes.data.all_hotels_data);
        const serviceData = {
          hotel_services: SectionRes.data.hotel_services,
          all_icons: SectionRes.data.all_icons,
          selected_services: SectionRes.data.selected_services,
        };
        setHotelServicesData(serviceData);
        // setHotelAboutDetails(SectionRes.data.hotel_about_details);
        if (SectionRes.data.services_section_details) {
          setServiceId(SectionRes.data.services_section_details.id);
          setSectionId(SectionRes.data.services_section_details.section_id);
          setDescription(
            SectionRes.data.services_section_details.section_description
          );
          setTitleText(SectionRes.data.services_section_details.section_title);
          setAltText(
            SectionRes.data.services_section_details.background_image_alt
          );
          SectionRes.data.services_section_details.background_image
            ? setServiceSecImage([
              getImage(
                SectionRes.data.services_section_details.background_image
              ),
            ])
            : setServiceSecImage([]);
        } else {
          setServiceId("undefined");
          setDescription("");
          setTitleText("");
          setAltText("");
          setServiceSecImage([]);
          setSectionId("");
        }
      } else {
        setHotelDetails([]);
        setServiceData([]);
        setHotelServicesData({});
      }
    } catch (error: any) {
      // toast.error(CATCH_MESSAGE);
      console.log(error);
    }
  };

  function saveHandler() {
    if (editServicefiles.length) {
      uploadHandler();
    } else {
      addUpdateServices("undefined");
    }
  }

  const uploadHandler = async () => {
    if (editServicefiles.length === 1) {
      setLoader(true);

      let payload = new FormData();

      payload.append("uploadFile[0]", editServicefiles[0]);
      try {
        let uploadRes = await wbApi.post(
          `/wb/insert-dz-images/${company_id}/${template_id}/services_background_image`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + auth_token,
            },
          }
        );
        // console.log("uploadRes", uploadRes);
        if (uploadRes.data.status === 1) {
          await addUpdateServices(uploadRes.data.image_ids);
          setLoader(false);
        } else {
          toast.error(uploadRes.data.message);
          setLoader(false);
        }
      } catch {
        toast.error(CATCH_MESSAGE);
        setLoader(false);
      }
    } else {
      toast.error("Only One Image Allowed");
    }

  };

  // Update Promo Section

  const addUpdateServices = async (image_ids: any) => {
    setLoader(true);
    try {
      let req = await wbApi.post("/wb/insert-update-default-section-details", {
        id: serviceId ?? "undefined",
        background_image: image_ids,
        section_id: defaultSectionId,
        background_image_alt: altText ?? "",
        company_id: company_id,
        template_id: template_id,
        section_title: titleText ?? "",
        section_description: description ?? "",
      });
      if (req.data.status === 1) {
        toast.success(req.data.message);
        fetchSection();
        setLoader(false);
        setRefreshList(!refreshList);
      } else {
        toast.error(req.data.message);
        fetchSection();
        setLoader(false);
      }
    } catch (error) {
      toast.error(CATCH_MESSAGE);
    }
  };
  // Delete Service Background Image
  const delteServiceSecFilesApi = async () => {
    try {
      let deleteRes = await wbApi.post(
        `/wb/delete-dz-default-section-background-image`,
        {
          company_id: company_id,
          image_name: serviceData.background_image,
          template_id: template_id,
          section_id: defaultSectionId,
        }
      );
      // console.log("deleteRes", deleteRes);
      if (deleteRes.data.status === 1) {
        toast.success(deleteRes.data.message);
        fetchSection();
      } else {
        toast.error(deleteRes.data.message);
        fetchSection();
      }
    } catch {
      toast.error(CATCH_MESSAGE);
    }
  };
  return (
    <>
      {/* Sub Header */}
      <div className="wb-subheader">
        <CustomBreadcrumbs
          content={[
            {
              label: "Sections",
              href: "/section-default",
            },
            {
              label: `Default Section`,
              href: "/section-default",
            },
            {
              label: " Edit Services",
            },
          ]}
        />
        <div className="wb-subheader-rightsec">
          <Button
            icon="bi bi-arrow-left"
            className="bck-btn"
            handleClick={() => {
              navigate(-1);
            }}
          >
            Back
          </Button>
        </div>
      </div>
      <div className="wb-divider"></div>

      {/* Main Section */}

      <CardWrapper className="mt-4 mb-4 edit-promo-conatiner">
        <div className="edit-aboutus-text-container">
          <InputTextField
            label="Enter Title"
            value={titleText}
            className="edit-aboutus-subheader"
            handleChange={(e) => {
              setTitleText(e.target.value);
            }}
          />
          <InputTextField
            label="Enter Alternate Text"
            value={altText}
            className="edit-aboutus-alt-text"
            handleChange={(e) => {
              setAltText(e.target.value);
            }}
          />
        </div>

        <div className="edit-promo-alt-label">
          Select Your Back Ground Image
        </div>
        <DropzoneArea
          centerMesage={"Drag your photos or click here(1 Image Only)"}
          incomingfiles={serviceSecImage}
          dispatchFiles={(val) => accpServiceFiles(val)}
          isDelete={(val) => delteServiceFiles(val)}
          acceptFileExt="image/jpg,image/jpeg,image/png,image/gif"
          refresh={refreshList}
        />
        <div className="mt-4">
          <CKEditor
            editor={ClassicEditor}
            data={description}
            config={{
              removePlugins: [
                "EasyImage",
                "ImageUpload",
                "MediaEmbed",
                "Table",
              ],
            }}
            onChange={(event: string, editor: any) => {
              const data = editor.getData();
              setDescription(data);
              setCharCount({
                ...charCount,
                terms_cond: removeTags(data).length,
              });
            }}
          />
        </div>
        <div className="mt-4 edit-promo-btn-container">
          <Button
            className="cancel__btn"
            handleClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </Button>
          <Button
            className="save-btn"
            handleClick={() => {
              saveHandler();
            }}
            loader={loader}
          >
            Save
          </Button>
        </div>
      </CardWrapper>

      <div className="select__hotel__label">Select Hotels</div>
      <div className="default_section_image_card_container mt-3">
        {hotelDetails?.length > 0 ? (
          hotelDetails?.map((item: any) => (
            <div
              key={item.hotel_id}
              className="default__setion__image"
              onClick={() => {
                navigate(
                  "/section-default/edit-hotel-specifications/edit-hotel-services"
                );
                dispatch(
                  HotelServicesDataAction({
                    ...hotelServicesData,
                    hotel_id: item.hotel_id,
                    hotel_name: item.hotel_name,
                  })
                );
                // setHotelId(item.hotel_id);
                // setHotelName(item.hotel_name);
              }}
            >
              <div className="image__container">
                {
                  item?.hotel_image ? (
                    <img
                      src={item.hotel_image}
                      alt={item.hotel_name}
                      className="default__setion__image__image"
                    />
                  ) : (
                    <div className="image_container_icon_wrapper">
                      <FontAwesomeIcon icon={Icons.faHotel} size="2x" color="blue" />
                    </div>

                  )
                }
                <div className="hotel__name">{Capitalize(item.hotel_name)}</div>
              </div>
            </div>
          ))
        ) : (
          <NoDataComponent message={"No Hotels Found"} />
        )}
      </div>
      <div className="sixtypx-height"></div>

      {/* <SlidingPane
        hideHeader
        from="right"
        width="35%"
        isOpen={aboutSliderOpen}
        className="sliding-pane-custom"
        closeIcon={<i className="bi bi-x-lg"></i>}
        onRequestClose={() => setAboutSliderOpen(false)}
      >
        <AboutHotelSlider
          onClose={() => {
            setAboutSliderOpen(false);
          }}
          hotelId={hotelId}
          hotelName={hotelName}
          hotelAboutDetails={hotelAboutDetails}
          fetchSection={fetchSection}
        />
      </SlidingPane> */}
    </>
  );
};

export default EditServices;
